import { render, staticRenderFns } from "./audio-info.vue?vue&type=template&id=183acb93&scoped=true&"
import script from "./audio-info.vue?vue&type=script&lang=js&"
export * from "./audio-info.vue?vue&type=script&lang=js&"
import style0 from "./audio-info.vue?vue&type=style&index=0&id=183acb93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183acb93",
  null
  
)

export default component.exports